import { Outlet } from "react-router-dom";
import PublicNavBarV2 from "../../components/layouts/PublicNavBarV2";

function RootPublicLayout() {
  return (
    <>
      <PublicNavBarV2 />
      <Outlet />
    </>
  );
}

export default RootPublicLayout;
